import { useOrganizations } from '@contexts/organizations-provider';
import { useMutation } from '@tanstack/react-query';
import * as React from 'react';

import type {
  UseCreateChangeRequestParams,
  UseCreateChangeRequestReturn,
} from './useCreateChangeRequest.types';

import { createChangeRequest } from '../../api/create-change-request/createChangeRequest';

export function useCreateChangeRequest({
  config,
}: UseCreateChangeRequestParams): UseCreateChangeRequestReturn {
  const { selectedOrganization } = useOrganizations();

  const mutation = useMutation<void, Error, { title: string; text: string }>({
    mutationFn: ({ title, text }): Promise<void> => {
      if (!selectedOrganization) {
        return Promise.reject(new Error('Missing organization'));
      }

      return createChangeRequest(selectedOrganization.id, {
        title,
        text,
        type: config.type,
        metadata: config.metadata,
      });
    },
  });

  const { mutateAsync } = mutation;

  const createRequest = React.useCallback(
    async (title: string, text: string): Promise<void> => {
      await mutateAsync({ title, text });
    },
    [mutateAsync]
  );

  return {
    isLoading: mutation.isPending,
    isSuccess: mutation.isSuccess,
    isError: mutation.isError,
    createRequest,
    reset: mutation.reset,
  };
}
